import useForm from '@src/hooks/useForm';

import Row from '@src/components/ContactForm/components/Row';
import Input from '@src/components/ContactForm/components/Input';
import Select from '@src/components/ContactForm/components/Select';
import Textarea from '@src/components/ContactForm/components/Textarea';

import styles from './styles/index.module.scss';

const title = JSON.parse(document.querySelector('#jobJson').textContent)?.title as string;

type InitType = {
  title: string,
  name: string,
  kana: string,
  address: string,
  email: string,
  tel: string,
  school: string,
  grade: string,
  know: number | ''
  content: string,
};

const init: InitType = {
  title,
  name: '',
  kana: '',
  address: '',
  email: '',
  tel: '',
  school: '',
  grade: '',
  know: '',
  content: '',
};

export default function Form() {
  const [{ formRef, state, finish }, { handleInput, handleSelect, handleSubmit }] = useForm(init, './api/article.php');

  if (!state.title) {
    return;
  }

  return (
    <>
      <form ref={formRef} className={styles.form}>
        <table className={styles.table}>
          <tbody className={styles.tbody}>
            <Row title="お名前" required>
              <Input name="name" required value={state.name} onInput={handleInput} placeholder="メルコ　太郎" autocomplete="name" />
            </Row>
            <Row title="フリガナ" required>
              <Input name="kana" required value={state.kana} onInput={handleInput} placeholder="メルコ　タロウ" />
            </Row>
            <Row title="ご住所" required>
              <Input name="address" required value={state.address} onInput={handleInput} placeholder="〒981-2402　宮城県伊具郡丸森町金山字西新田123-1" />
            </Row>
            <Row title="メールアドレス" required>
              <Input name="email" type="email" required value={state.email} onInput={handleInput} placeholder="melco_japan@sample.com" autocomplete="email" />
            </Row>
            <Row title="連絡先電話番号" required>
              <Input name="tel" type="tel" required value={state.tel} onInput={handleInput} placeholder="0224000000" autocomplete="tel" />
            </Row>
            <Row title="出身校" required>
              <Input name="school" required value={state.school} onInput={handleInput} placeholder="メルコ工業高等学校" />
            </Row>
            <Row title="学年">
              <Input name="grade" value={state.grade} onInput={handleInput} placeholder="3年" />
            </Row>
            <Row title="メルコジャパンをどこでお知りになりましたか？" required>
              <Select name="know" required value={state.know} onChange={handleSelect} array={[
                { value: '', text: '選択してください'},
                { value: 1, text: '学校、大学、専門学校等の就職指導室からの情報提供' },
                { value: 2, text: 'ハローワークからの情報提供' },
                { value: 3, text: '就職・転職専門サイトからの情報提供' },
                { value: 4, text: 'その他' },
              ]} />
            </Row>
            <Row title="お問合せ内容" required>
              <Textarea name="content" required value={state.content} onInput={handleInput} />
            </Row>
          </tbody>
        </table>
        {finish === 'error' && (
          <p className={styles.error}>エラーが発生しました。内容を確認の上再送してください。</p>
        )}
        {finish === 'sending' && (
          <p className={styles.sending}>現在送信中です。</p>
        )}
        {finish === 'complete' && (
          <p className={styles.complete}>送信が完了しました。</p>
        )}
        <button type="button" className={styles.submitBtn} onClick={handleSubmit}>送信する</button>
      </form>
    </>
  );
}